import React from "react";
import { OrderWaiting } from "../../../types/elements";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
interface OrderWaitingListProps {
  list: OrderWaiting[];
}
const OrderWaitingList: React.FC<OrderWaitingListProps> = (props) => {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>ID</TableCell>
          <TableCell>Price</TableCell>
          <TableCell>Login User</TableCell>
          <TableCell>User</TableCell>
          <TableCell>To</TableCell>
          <TableCell>Addrss</TableCell>
          <TableCell>Items</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {props.list.map((o) => {
          return (
            <TableRow>
              <TableCell>{o.id}</TableCell>
              <TableCell>{o.price}</TableCell>
              <TableCell>
                #{o.user_id} {o.user?.name}
              </TableCell>
              <TableCell>
                {o.username} <br />
                {o.useremail} <br />
                {o.userphone}
              </TableCell>
              <TableCell>
                {o.addr_username} <br />
                {o.addr_phone}
              </TableCell>
              <TableCell>
                {o.addr_zipcode} <br />
                {o.addr_addr1} <br />
                {o.addr_addr2}
              </TableCell>
              <TableCell>
                {o.orderWaitingItems?.map((oi) => {
                  return (
                    <div>
                      [#{oi.item_id}-#{oi.item_option_id}] {oi.item?.name} * {oi.count}
                    </div>
                  );
                })}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default OrderWaitingList;
